module.exports = __webpack_public_path__ + "static/media/Glassware.0514b1a2.png";